import React, {PropTypes} from 'react';
import DateTime from 'react-datetime';
import moment from 'moment-timezone';
import 'moment/locale/nb';
import './datetime.scss';


const DateTimeInput = ({name, label, helpText, wrapperClass, onChange, placeholder, required, value, error}) => {
  wrapperClass += " form-group";
  if(error && error.lendth > 0) {
    wrapperClass += " " + 'has-error';
  }
  function updateTime(time) {
    if (time) {
      onChange(name, time.format('YYYY-MM-DDTHH:mm:ssZ'));
    } else {
      onChange(name, null);
    }
  }
  let InitialDate = value ? moment.tz(value, 'Europe/Oslo') : undefined;
  return (
    <div className={wrapperClass}>
      <label htmlFor={name}>{label}</label>
        <DateTime
          label={label}
          input={true}
          locale="no"
          value={InitialDate}
          inputProps={{
            name: name,
            placeholder: placeholder,
            required: required
          }}
          onChange={updateTime}/>
        <div className="help-block">{helpText}</div>
        {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

// Note that this odd style is utilized for propType validation for now. Must be defined *after*
// the component is defined, which is why it's separate and down here.
DateTimeInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  helpText: PropTypes.string,
  required: PropTypes.bool,
  wrapperClass: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
};

export default DateTimeInput;



/** WEBPACK FOOTER **
 ** ./src/components/common/DateTimeInput.js
 **/